import React, { PropTypes } from 'react';
import RefLine from './RefLine';
import RefDetailModal from './RefDetailModal';
import $ from 'jquery';

export class RefDetail extends React.Component {
  static propTypes = {
    buttonLabel: PropTypes.string.isRequired,
    columnLabel: PropTypes.string,
    lines: PropTypes.array.isRequired,
    onChange: PropTypes.func,
    dirtyFormSupport: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      lines: props.lines,
      modalOpened: false,
      current: -1,
      deletedIds: [],
      currentLine: {},
    };

    this.onEditClick = this.onEditClick.bind(this);
    this.onNewClick = this.onNewClick.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.onModalSave = this.onModalSave.bind(this);
    this.onDeleteLine = this.onDeleteLine.bind(this);
  }

  onEditClick(index) {
    return info => {
      this.setState({
        current: index,
        modalOpened: true,
      });
    };
  }

  onNewClick(evt) {
    evt.preventDefault();
    this.setState({
      current: this.state.lines.length,
      modalOpened: true,
    });
  }

  onModalClose() {
    this.setState({ modalOpened: false });
  }

  onModalSave(index) {
    return line => {
      const newLines = this.state.lines;
      newLines[index] = line;

      this.setState({
        modalOpened: false,
        lines: newLines,
      });

      if (this.props.onChange) {
        this.props.onChange(newLines);
      }
    };
  }

  onDeleteLine(index) {
    return evt => {
      const toDelete = this.state.lines[index];

      if (toDelete.id) {
        this.setState({ deletedIds: [...this.state.deletedIds, toDelete.id] });
      }

      let updatedLines = [...this.state.lines];
      updatedLines.splice(index, 1);
      this.setState({
        lines: updatedLines,
      });
    };
  }

  getLinesAsJson() {
    return JSON.stringify(this.getLines());
  }

  getLines() {
    return this.state.lines;
  }

  getDeletedIds() {
    return this.state.deletedIds;
  }

  getPrefix() {
    return this.props.prefix;
  }

  componentDidUpdate() {
    const $form = $('form.ui.form');
    if ($form && $form.length && this.props && this.props.dirtyFormSupport) {
      $form.addClass('dirty');
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.props.onChange) {
      this.props.onChange(nextState);
    }
  }

  render() {
    const { lines, current, modalOpened } = this.state;
    const { buttonLabel } = this.props;

    const currentLine = lines[current] || {};

    return (
      <table className="ui table">
        <thead>
          <tr>
            <th className="five wide">
              <a href="#" className="ui button" onClick={this.onNewClick}>
                <i className="add icon" />
                {buttonLabel}
              </a>
            </th>
            <th>{this.props.columnLabel || 'Valeurs'}</th>
          </tr>
        </thead>
        <tbody>
          {lines &&
            lines.map(l => (
              <RefLine
                key={lines.indexOf(l)}
                data={l}
                onEdit={this.onEditClick(lines.indexOf(l))}
                onDelete={this.onDeleteLine(lines.indexOf(l))}
              />
            ))}
        </tbody>
        <RefDetailModal
          visible={modalOpened}
          index={current}
          line={currentLine}
          onClose={this.onModalClose}
          onSave={this.onModalSave(current)}
        />
      </table>
    );
  }
}

export default RefDetail;



// WEBPACK FOOTER //
// ./src/modules/saas/common/references/RefEditor.js